interface BrushFilterChipProps {
  /** RT 필터 범위 설명 문자열. null이면 렌더하지 않음. */
  brushLabel: string | null;
  /** 칩 해제 버튼 클릭 핸들러 */
  onClear: () => void;
}

/**
 * TIC 브러시 적용 상태를 알리는 칩 컴포넌트.
 * brushLabel이 null이면 아무것도 렌더하지 않음 (조건부 렌더).
 */
export default function BrushFilterChip({
  brushLabel,
  onClear,
}: BrushFilterChipProps) {
  if (!brushLabel) return null;

  return (
    <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-100 border border-blue-300 text-blue-800 text-xs font-medium">
      <span>{brushLabel}</span>
      <button
        type="button"
        onClick={onClear}
        aria-label="RT 필터 해제"
        className="flex items-center justify-center w-4 h-4 rounded-full hover:bg-blue-200 transition-colors"
      >
        <svg
          viewBox="0 0 12 12"
          fill="currentColor"
          className="w-3 h-3"
          aria-hidden="true"
        >
          <path d="M2.22 2.22a.75.75 0 0 1 1.06 0L6 4.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L7.06 6l2.72 2.72a.75.75 0 1 1-1.06 1.06L6 7.06 3.28 9.78a.75.75 0 0 1-1.06-1.06L4.94 6 2.22 3.28a.75.75 0 0 1 0-1.06Z" />
        </svg>
      </button>
    </div>
  );
}
